import axios from 'axios';

export default function postPresignedUrl(acceptedFiles, params, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postCreatePresignedUrl;

    const data = {
        key: params.key,
        bucket: params.bucket,
        method: params.method,
        metadata: params.fields
    }

    const respData = new FormData();
    
    return dispatch => dispatch({
        type: 'PRESIGNED_FILE_UPLOAD_FETCH',
        payload: axios({ method: 'POST', url, headers, data }).then((response) => {
            Object.keys(response.data.preSignedUrl.fields).forEach(field => respData.append(field, response.data.preSignedUrl.fields[field]));
            respData.append('bucket', params.bucket);
            respData.append('file', acceptedFiles[0]);

            const headersPreSigned = {};
            Object.keys(response.data.preSignedUrl.fields).filter((field) => {
                if (field.includes('x-amz-meta')) {
                    headersPreSigned[field] = response.data.preSignedUrl.fields[field];
                }
            });
            
            // now do a PUT request to the pre-signed URL
            // axios({ method: 'POST', })
            const urlPresigned = response.data.preSignedUrl.url;
            axios({ method: 'POST', url: urlPresigned, headers: headersPreSigned, data: respData }).then((resp) => {
            }).catch((e) => {
                console.error(e);
            });
        }).catch((e) => {
            console.error(e);
        })
    });

}


// WEBPACK FOOTER //
// ./src/actions/postPresignedUrl.js